import { defineMessages } from 'react-intl';

export default defineMessages({
  select: {
    id: 'cboard.components.Board.EditToolbar.select',
    defaultMessage: 'Select'
  },
  cancel: {
    id: 'cboard.components.Board.EditToolbar.cancel',
    defaultMessage: 'Cancel'
  },
  deleteTiles: {
    id: 'cboard.components.Board.EditToolbar.deleteTiles',
    defaultMessage: 'Delete selected tiles'
  },
  deleteTileTitle: {
    id: 'cboard.components.Board.EditToolbar.deleteTileTitle',
    defaultMessage: 'Delete Tiles'
  },
  deleteTileDescription: {
    id: 'cboard.components.Board.EditToolbar.deleteTileDescription',
    defaultMessage: 'Are you sure you want to delete the tile(s)?'
  },
  deleteTileCancel: {
    id: 'cboard.components.Board.EditToolbar.deleteTileCancel',
    defaultMessage: 'Cancel'
  },
  deleteTileOk: {
    id: 'cboard.components.EditToolbar.Board.deleteTileOk',
    defaultMessage: 'Delete'
  },
  editTiles: {
    id: 'cboard.components.Board.EditToolbar.editTiles',
    defaultMessage: 'Edit selected tiles'
  },
  createTiles: {
    id: 'cboard.components.Board.EditToolbar.createTiles',
    defaultMessage: 'Create tiles'
  },
  editTilesButton: {
    id: 'cboard.components.Board.EditToolbar.editTilesButton',
    defaultMessage: 'Edit'
  },
  addTileButton: {
    id: 'cboard.components.Board.EditToolbar.addTileButton',
    defaultMessage: 'Add Tile'
  },
  fixedBoard: {
    id: 'cboard.components.Board.EditToolbar.fixedBoard',
    defaultMessage: 'Fixed'
  },
  copyTiles: {
    id: 'cboard.components.Board.EditToolbar.copyTiles',
    defaultMessage: 'Copy tiles'
  },
  pasteTiles: {
    id: 'cboard.components.Board.EditToolbar.pasteTiles',
    defaultMessage: 'Paste tiles'
  }
});
